import { Component, input, output } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { SpecLot } from '../../../models/build-spec-models.models';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-build-spec-models-table',
  imports: [TableModule, DatePipe],
  templateUrl: './build-spec-models-table.component.html',
  styleUrl: './build-spec-models-table.component.scss'
})
export class BuildSpecModelsTableComponent {
  specLots = input<SpecLot[]>([]);
  rowClick = output<SpecLot>();

  onRowClick(specLot: SpecLot): void {
    this.rowClick.emit(specLot);
  }
}
